export default "__VITE_ASSET__C5ciqjf5__"